/**
 * Lightweight corner save status for Surveys (Beta) authoring.
 * Design gap: no approved “autosave status” pattern in portal DS yet — uses caption neutrals.
 */
export type SurveysBetaSyncState = 'idle' | 'saving' | 'saved' | 'error';

const LABELS: Record<Exclude<SurveysBetaSyncState, 'idle'>, string> = {
  saving: 'Saving…',
  saved: 'Saved',
  error: 'Save failed',
};

export function SurveysBetaSyncStatus({ status }: { status: SurveysBetaSyncState }) {
  if (status === 'idle') {
    return null;
  }

  return (
    <div
      role="status"
      aria-live="polite"
      className={[
        'fixed bottom-5 right-5 z-40 rounded-lg border border-[#EDEEF2] bg-white',
        'px-3 py-1.5 text-[12px] font-medium tracking-[-0.1px] shadow-[0_1px_2px_rgba(13,15,26,0.08)]',
        status === 'error' ? 'text-[#DC2626]' : 'text-[#5E6278]',
      ].join(' ')}
    >
      {LABELS[status]}
    </div>
  );
}
